import { connect } from 'react-redux';
import { compose} from 'recompose';

import SingBook from './SingBook';

const mapStateToProps = state => ({
    data: state,
});

export default compose(
    connect(mapStateToProps),
)(SingBook);
